import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import './Pages.css';

export const Privacy: React.FC = () => {
  return (
    <div className="ns-legal-page">
      <header className="ns-legal-header">
        <div className="ns-legal-header-content">
          <Link to="/" className="ns-legal-logo">
            <span className="mark">NS</span>
            <span className="text">NutriSync</span>
          </Link>
          <Link to="/">
            <Button variant="secondary">Voltar ao início</Button>
          </Link>
        </div>
      </header>

      <main className="ns-legal-main">
        <div className="ns-legal-container">
          <h1>Política de Privacidade</h1>
          <p className="ns-legal-intro">
            Esta Política de Privacidade descreve como o NutriSync coleta, usa, armazena e 
            protege suas informações pessoais. Estamos comprometidos em proteger sua privacidade 
            e garantir a segurança de seus dados.
          </p>
          <p className="ns-legal-updated">
            <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section className="ns-legal-section">
            <h2>1. Informações que Coletamos</h2>
            
            <h3>1.1. Informações Fornecidas por Você</h3>
            <p>Ao utilizar o NutriSync, coletamos as seguintes informações:</p>
            <ul className="ns-legal-list">
              <li><strong>Dados de Cadastro:</strong> Nome, e-mail, telefone, CRN</li>
              <li><strong>Dados de Pagamento:</strong> Informações de cartão de crédito (processadas por provedores seguros terceirizados)</li>
              <li><strong>Dados de Perfil:</strong> Informações profissionais e preferências</li>
              <li><strong>Dados de Pacientes:</strong> Informações fornecidas por você sobre seus pacientes</li>
              <li><strong>Comunicações:</strong> Mensagens e comunicações através da plataforma</li>
            </ul>

            <h3>1.2. Informações Coletadas Automaticamente</h3>
            <ul className="ns-legal-list">
              <li><strong>Dados de Uso:</strong> Como você interage com a plataforma</li>
              <li><strong>Dados de Dispositivo:</strong> Tipo de dispositivo, navegador, endereço IP</li>
              <li><strong>Cookies e Tecnologias Similares:</strong> Para melhorar a experiência e analisar o uso</li>
              <li><strong>Logs:</strong> Registros de acesso e atividades na plataforma</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>2. Como Usamos Suas Informações</h2>
            <p>Utilizamos suas informações pessoais para:</p>
            <ul className="ns-legal-list">
              <li><strong>Prestar Serviços:</strong> Fornecer e melhorar a plataforma NutriSync</li>
              <li><strong>Processar Pagamentos:</strong> Gerenciar assinaturas e processar pagamentos</li>
              <li><strong>Comunicação:</strong> Enviar notificações, atualizações e suporte</li>
              <li><strong>Segurança:</strong> Proteger contra fraudes e garantir a segurança da plataforma</li>
              <li><strong>Análise e Melhoria:</strong> Analisar o uso para melhorar nossos serviços</li>
              <li><strong>Conformidade Legal:</strong> Cumprir obrigações legais e regulatórias</li>
              <li><strong>Marketing:</strong> Enviar comunicações sobre produtos e serviços (com seu consentimento)</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>3. Compartilhamento de Informações</h2>
            <p>Não vendemos suas informações pessoais. Podemos compartilhar informações apenas nas seguintes situações:</p>

            <h3>3.1. Prestadores de Serviços</h3>
            <p>
              Compartilhamos informações com empresas que nos auxiliam na operação da plataforma, 
              como hospedagem, processamento de pagamentos e análise de dados. Essas empresas são 
              contratualmente obrigadas a proteger suas informações.
            </p>

            <h3>3.2. Obrigações Legais</h3>
            <p>
              Podemos divulgar informações quando exigido por lei, ordem judicial ou autoridades 
              competentes.
            </p>

            <h3>3.3. Com Seu Consentimento</h3>
            <p>
              Compartilhamos informações com terceiros quando você nos dá permissão explícita.
            </p>

            <h3>3.4. Transferências de Negócio</h3>
            <p>
              Em caso de fusão, aquisição ou venda de ativos, suas informações podem ser transferidas 
              como parte da transação.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>4. Segurança dos Dados</h2>
            <p>
              Implementamos medidas técnicas e organizacionais adequadas para proteger suas informações:
            </p>
            <ul className="ns-legal-list">
              <li><strong>Criptografia:</strong> Dados criptografados em trânsito (HTTPS/TLS) e em repouso</li>
              <li><strong>Controle de Acesso:</strong> Acesso restrito apenas a pessoal autorizado</li>
              <li><strong>Monitoramento:</strong> Monitoramento contínuo de segurança</li>
              <li><strong>Backups:</strong> Backups regulares e seguros</li>
              <li><strong>Treinamento:</strong> Equipe treinada em segurança da informação</li>
              <li><strong>Auditorias:</strong> Auditorias periódicas de segurança</li>
            </ul>
            <p>
              Embora tomemos medidas razoáveis para proteger suas informações, nenhum sistema é 
              100% seguro. Você também é responsável por manter a segurança de sua conta e senha.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>5. Retenção de Dados</h2>
            <p>
              Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir as 
              finalidades para as quais foram coletadas, ou conforme exigido por lei. Quando os 
              dados não forem mais necessários, serão eliminados de forma segura.
            </p>
            <p>
              Dados de pacientes são mantidos enquanto você mantiver uma conta ativa e por um 
              período adicional conforme exigido por lei ou regulamentação profissional.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>6. Seus Direitos</h2>
            <p>Você tem os seguintes direitos em relação às suas informações pessoais:</p>
            
            <div className="ns-rights-grid">
              <div className="ns-right-card">
                <div className="ns-right-icon">🔍</div>
                <h3>Acesso</h3>
                <p>Solicitar acesso às suas informações pessoais que mantemos.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">✏️</div>
                <h3>Correção</h3>
                <p>Solicitar a correção de informações imprecisas ou incompletas.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">🗑️</div>
                <h3>Exclusão</h3>
                <p>Solicitar a exclusão de suas informações pessoais.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">📋</div>
                <h3>Portabilidade</h3>
                <p>Receber suas informações em formato estruturado e portável.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">🚫</div>
                <h3>Oposição</h3>
                <p>Opor-se ao processamento de suas informações em certas circunstâncias.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">⏸️</div>
                <h3>Restrição</h3>
                <p>Solicitar a restrição do processamento de suas informações.</p>
              </div>
            </div>

            <p>
              Para exercer qualquer um desses direitos, entre em contato conosco através de 
              privacidade@nutrisync.com.br ou através das configurações da sua conta.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>7. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar 
              o uso da plataforma e personalizar conteúdo. Os tipos de cookies que utilizamos incluem:
            </p>
            <ul className="ns-legal-list">
              <li><strong>Cookies Essenciais:</strong> Necessários para o funcionamento da plataforma</li>
              <li><strong>Cookies de Desempenho:</strong> Para analisar como você usa a plataforma</li>
              <li><strong>Cookies de Funcionalidade:</strong> Para lembrar suas preferências</li>
              <li><strong>Cookies de Marketing:</strong> Para personalizar anúncios (com seu consentimento)</li>
            </ul>
            <p>
              Você pode gerenciar suas preferências de cookies através das configurações do seu 
              navegador. Note que desabilitar cookies pode afetar a funcionalidade da plataforma.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>8. Privacidade de Crianças</h2>
            <p>
              O NutriSync não é destinado a menores de 18 anos. Não coletamos intencionalmente 
              informações pessoais de menores. Se você é pai/mãe ou responsável e acredita que 
              seu filho nos forneceu informações, entre em contato conosco.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>9. Transferências Internacionais</h2>
            <p>
              Seus dados podem ser processados e armazenados em servidores localizados fora do 
              Brasil. Ao utilizar a plataforma, você consente com a transferência de suas 
              informações para esses servidores. Garantimos que essas transferências são feitas 
              com medidas adequadas de proteção.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>10. Links para Sites de Terceiros</h2>
            <p>
              Nossa plataforma pode conter links para sites de terceiros. Não somos responsáveis 
              pelas práticas de privacidade desses sites. Recomendamos que você leia as políticas 
              de privacidade de qualquer site que visite.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>11. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre 
              mudanças significativas através de e-mail ou aviso na plataforma. A data da última 
              atualização está indicada no topo desta página.
            </p>
            <p>
              Recomendamos revisar esta política regularmente para estar ciente de como protegemos 
              suas informações.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>12. Conformidade com LGPD</h2>
            <p>
              Esta Política de Privacidade está em conformidade com a Lei Geral de Proteção de 
              Dados (LGPD - Lei nº 13.709/2018). Para mais informações sobre nossos compromissos 
              com a LGPD, consulte nossa página de Conformidade com LGPD.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>13. Contato</h2>
            <p>
              Se você tiver dúvidas, preocupações ou solicitações relacionadas a esta Política 
              de Privacidade ou ao tratamento de seus dados pessoais, entre em contato:
            </p>
            <div className="ns-contact-info">
              <p><strong>NutriSync - Encarregado de Proteção de Dados (DPO)</strong></p>
              <p>E-mail: privacidade@nutrisync.com.br</p>
              <p>E-mail DPO: dpo@nutrisync.com.br</p>
              <p>Telefone: (11) 0000-0000</p>
            </div>
          </section>

          <div className="ns-legal-footer-actions">
            <Link to="/">
              <Button>Voltar ao início</Button>
            </Link>
            <Link to="/termos-de-uso">
              <Button variant="secondary">Ver Termos de Uso</Button>
            </Link>
            <Link to="/lgpd">
              <Button variant="secondary">Ver LGPD</Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

